import {makeStyles, Theme} from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: "30px 0",
    width: "100%",
    maxWidth: 1200,
    margin: "0 auto",
    overflow: "hidden",
    [theme.breakpoints?.down("md")]: {
      padding: "20px 0",
    },
    [theme.breakpoints?.down("sm")]: {
      padding: "16px 0",
    },
  },
  headerBanner: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: 16,
  },
  headerTitleGroup: {
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  headerIconPill: {
    width: 48,
    height: 48,
    borderRadius: 14,
    background: "linear-gradient(135deg, #0284C7 0%, #0369A1 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFFFFF",
    boxShadow: "0 6px 18px rgba(2, 132, 199, 0.3)",
  },
  title: {
    color: "#0F172A",
    fontSize: "1.35rem",
    fontWeight: 800,
    letterSpacing: "0.02em",
    [theme.breakpoints?.down("sm")]: {
      fontSize: "1.1rem",
    },
  },
  subtitle: {
    fontSize: "0.85rem",
    color: "#64748B",
    fontWeight: 500,
  },
  formControl: {
    minWidth: 140,
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    border: "1px solid #CBD5E1",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.04)",
    "& .MuiSelect-root": {
      padding: "8px 16px",
      fontSize: "0.9rem",
      fontWeight: 700,
      color: "#1E293B",
    },
  },
  summaryGrid: {
    marginBottom: 40,
  },
  summaryCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 18,
    padding: "12px 20px",
    border: "1px solid #E2E8F0",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.04)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "0 14px 28px rgba(0, 0, 0, 0.08)",
    },
  },
  container_table: {
    maxHeight: "65vh",
    borderRadius: 20,
    boxShadow: "0 10px 30px -5px rgba(0, 0, 0, 0.05), 0 4px 12px rgba(0, 0, 0, 0.03)",
    border: "1px solid #E2E8F0",
    overflowX: "auto",
    "& .MuiTable-root": {
      minWidth: 650,
    },
    "& .MuiTableRow-root:nth-of-type(even)": {
      backgroundColor: "#F8FAFC",
    },
  },
  mobileCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: "16px 18px",
    border: "1px solid #E2E8F0",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
    transition: "all 0.25s ease",
    marginBottom: 12,
    "&:active": {
      transform: "scale(0.98)",
      backgroundColor: "#F8FAFC",
    },
  },
}));

export default useStyles;
